// :cow: Cosmose CONFIDENTIAL :iso:
export enum DropdownItemTypes {
  Info = 'info',
  Link = 'link',
}
